import React, { PureComponent } from "react";
import { message } from "antd";
import Http from "../../networkReq/http";
import Request from "../../networkReq/request";
import { useHistory } from "react-router-dom";
import { showhtml } from "utils/methods";
// require("./index.css");
import "./index.scss";

import jobImg1 from "@/images/home/jobImg1.jpg";
import jobImg2 from "@/images/home/jobImg2.jpg";
import qrcode from "@/images/home/qrcode.jpg";
import jobImg3 from "@/images/home/jobImg3.jpg";
import jobImg4 from "@/images/home/jobImg4.jpg";
import jobImg5 from "@/images/home/jobImg5.jpg";
import jobImg6 from "@/images/home/jobImg6.jpg";
export default class Index extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      dataInfo: {},
      jobHot: []
    };
  }

  componentDidMount = () => {
    // const {
    //   location: { state },
    // } = this.props;
    // console.log(state.detail);
    // this.setState({
    //   dataInfo: state.detail || {}
    // })
    // console.log("searchsearch", this.props.location);
    // this.getDetail(state);

    let params = {
      current: 1,
      size: 1,
      categoryCode: "mslmrz", //
      descs: "update_time"
    };
    Http.get(
      Request.getInfoList(), params,
      (obj) => {
        if (obj.code == 200) {
          this.setState({
            jobHot: obj.data.records
          })
        } else {
          message.error(obj.msg || obj.message || "请求失败，请重试");
        }
      }
    );
  };

  render() {
    const { jobHot } = this.state;

    const toLink = (url) => {
      window.open(url, '_blank');
    }

    return (
      <div>
        <div className="infoBox" style={{ paddingTop: 30 }}>
          <div className="detailBox">
            <div
              className="backBtn"
              onClick={() => {
                // this.props.history.replace("/entrance/education");
                window.history.back(-1);
              }}
            >
              返回
            </div>
            <div className="title">
              <h2>就业招聘</h2>
            </div>
            {jobHot.length
              ? 
              <div className="JobHot">
                <div className="imgBox">
                  <img src={jobHot[0].image} alt=""/>
                </div>
                <div className="txtBox" onClick={() =>
                  this.props.history.push({
                    pathname: "/entrance/PolicyDetails",
                    state: { id: jobHot[0].id },
                  })
                }>
                  <div className="name">{jobHot[0].title}</div>
                  <div className="desc">{jobHot[0].abstracts}</div>
                </div>
              </div>
              :<div></div>
            }
            <div className="JobBoxList">
              <div className="JobItem" onClick={() => {
                toLink('http://www.rc139.com/');
              }}>
                  <div className="imgBox">
                    <img src={jobImg1} alt=""/>
                  </div>
                  <div className="name">眉山市人才资源网</div>
              </div>
              <div className="JobItem">
                  <div className="imgBox">
                    <img src={qrcode} className="imgH" alt=""/>
                  </div>
                  <div className="name">眉山同心人才网公众号</div>
              </div>
              <div className="JobItem" onClick={() => {
                toLink('https://job.m12333.cn/job/meishan.aspx');
              }}>
                  <div className="imgBox">
                    <img src={jobImg2} alt=""/>
                  </div>
                  <div className="name">眉山市人社通</div>
              </div>
              <div className="JobItem" onClick={() => {
                toLink('https://meishan.baixing.com/gongzuo/');
              }}>
                  <div className="imgBox">
                    <img src={jobImg4} alt=""/>
                  </div>
                  <div className="name">眉山市百姓网</div>
              </div>
              <div className="JobItem" onClick={() => {
                toLink('http://sctfh.cn/public/job/show/15.html');
              }}>
                  <div className="imgBox">
                    <img src={jobImg5} alt=""/>
                  </div>
                  <div className="name">四川省退役军人就业创业网</div>
              </div>
              <div className="JobItem" onClick={() => {
                toLink('http://cd.lianhezhaopin.com/Index/qzzp/citycategory/meishan.html');
              }}>
                  <div className="imgBox">
                    <img src={jobImg6} alt=""/>
                  </div>
                  <div className="name">成都市退役军人人才网</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
